import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import AppDetailContentPoint from './AppDetailContentPoint';
import { PartnerBulletPoints } from '../lib/constants';
import { get } from 'lodash';
import getContent from '../lib/dictionaryFetcher';

const AppDetailContentPoints = props => {
  const { partner, experimentation } = props,
    bulletPoints = get(PartnerBulletPoints, partner, []);

  return (
    <Fragment>
      {bulletPoints.map((content, index) => (
        <AppDetailContentPoint
          key={`app-detail-${content}-${index + 1}`}
          title={getContent(
            'merchanthub',
            `apps.${partner}.${content}.title`,
            ''
          )}
          points={getContent(
            'merchanthub',
            `apps.${partner}.${content}.points`,
            []
          )}
          experimentation={experimentation}
          partner={partner}
        />
      ))}
    </Fragment>
  );
};

AppDetailContentPoints.propTypes = {
  partner: PropTypes.string,
  experimentation: PropTypes.object
};

export default AppDetailContentPoints;
